// extracted by mini-css-extract-plugin
export default {"select":"userSelect_select__nBP9A"};